import React from 'react';
import { useRouter } from 'next/router';

import { PathContext } from 'app/context';
import SearchProvider from 'app/components/search/SearchProvider';
import BasePage from './BasePage';

const CommunityBasePage = ({ children, ...rest }) => {
  const router = useRouter();

  return (
    <PathContext.Provider value={{ path: router.pathname, host: 'seedly' }}>
      <SearchProvider>
        <BasePage {...rest}>{children}</BasePage>
      </SearchProvider>
    </PathContext.Provider>
  );
};

export default CommunityBasePage;
